import request from "@/utils/request";

export const userLogin = (data) => {
    return request({
        url: "/authservice/bm/user/login",
        method: "post",
        data: data
    })
}

export const orgUserLogin = (data) => {
    return request({
        url: "/authservice/bm/user/orgLogin",
        method: "post",
        data: data
    })
}